import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "linking-input__linking-container linking-container" }
const _hoisted_2 = { class: "linking-container__left" }
const _hoisted_3 = { class: "linking-container__at--content" }
const _hoisted_4 = { class: "linking-container__at--label label-container" }
const _hoisted_5 = { class: "linking-container__at--label" }
const _hoisted_6 = ["onUpdate:modelValue"]
const _hoisted_7 = { class: "label-container__unused-label" }
const _hoisted_8 = {
  key: 1,
  class: "linking-container__at--unused"
}
const _hoisted_9 = { class: "linking-container__at--error" }
const _hoisted_10 = { class: "linking-container__right" }

import { computed, onMounted } from 'vue';
import { i18n } from '@/i18n';
import { SelectYearMonthPattern, UploadInputFileType } from '../../interfaces/UploadFile';
import SelectableField from '../SelectableField.vue';
import { assertNever } from '@/coreDomainsModule/assertNever';
import {
  AlterableHeader,
  AlterableHeaderInfo,
  AlterableHeaderService,
  isRequireAlterableHeader,
  SelectYearMonthPatternInHeader,
  SelectYearMonthPatternInlined,
} from '../../interfaces/LinkingInput';
import InputExcelYearMonthInfo from './InputExcelYearMonthInfo.vue';

export type From = 'LinkingInput' | 'HomeInput' | 'FinishInput';


export default /*@__PURE__*/_defineComponent({
  __name: 'InputExcelForm',
  props: {
    from: {},
    selectedFieldId: {},
    suggestions: {},
    inputFileType: {},
    useFormatType: {},
    alterableHeaderInfos: {},
    inlinedYearMonthInfo: {},
    inHeaderYearMonthInfo: {}
  },
  emits: ["update-selected-field", "update-selected-field-id", "update-inline-header-name", "update-in-header-start-column-number", "update-in-header-end-column-number", "update-in-header-start", "update-in-header-end"],
  setup(__props: any, { emit: __emit }) {

const t = i18n.t;

/**
 * 呼び出し元
 */
const props = __props;

const emits = __emit;

/**
 * 選択されたフィールドを更新する
 * @param header - フィールド
 * @param updateValue - 更新する値
 */
const updateSelectedField = (header: AlterableHeaderInfo, updateValue: string) => {
  emits('update-selected-field', header, updateValue);
};

/**
 * 選択されたフィールドIDを更新する
 * @param id - フィールドID
 */
const updateSelectedFieldId = (id: string) => {
  emits('update-selected-field-id', id);
};

/**
 * 読み替え項目のヘッダー表示
 * @param header - ヘッダー
 */
const displayHeaderTitle = (header: AlterableHeader): string => {
  switch (header) {
    case 'WarehouseNumber':
      return addRequiredMark('WarehouseNumber', t('置場コード'));
    case 'Warehouse':
      return addRequiredMark('Warehouse', t('置場名'));
    case 'SupplierNumber':
      return addRequiredMark('SupplierNumber', t('仕入先コード'));
    case 'SupplierName':
      return addRequiredMark('SupplierName', t('仕入先名'));
    case 'BusinessNumber':
      return addRequiredMark('BusinessNumber', t('商品コード'));
    case 'BusinessName':
      return addRequiredMark('BusinessName', t('商品名'));
    case 'Package':
      return addRequiredMark('Package', t('容量'));
    case 'CustomerNumber':
      return addRequiredMark('CustomerNumber', t('売上先コード'));
    case 'CustomerName':
      return addRequiredMark('CustomerName', t('売上先名'));
    case 'SalesDestinationNumber':
      return addRequiredMark('SalesDestinationNumber', t('送り先コード'));
    case 'SalesDestinationName':
      return addRequiredMark('SalesDestinationName', t('送り先名'));
    case 'InventoryValue':
      return addRequiredMark('InventoryValue', t('在庫数量'));
    case 'SalesResultsValue':
      return addRequiredMark('SalesResultsValue', t('販売実績数量'));
    case 'ArrivalValue':
      return addRequiredMark('ArrivalValue', t('入荷実績数量'));
    case 'Manufacturer':
      return addRequiredMark('Manufacturer', t('製造社'));
    case 'EndUser':
      return addRequiredMark('EndUser', t('エンドユーザー'));
  }
};

/**
 * 読み替え項目のヘッダー表示（必須マーク付き）
 * @param header - ヘッダー名
 * @param value - ヘッダー表示
 * @returns - ヘッダー表示
 */
const addRequiredMark = (header: AlterableHeader, value: string): string => {
  return isRequireAlterableHeader(header) ? `${value} *` : value;
};

const headerList = computed(() => {
  switch (props.inputFileType) {
    case '在庫':
      return AlterableHeaderService.inventoryAlterableHeaderList;
    case '販売実績':
      return AlterableHeaderService.salesResultsAlterableHeaderList;
    case '入荷':
      return AlterableHeaderService.arrivalAlterableHeaderList;
    default:
      assertNever(props.inputFileType);
      return [];
  }
});

/**
 * getter
 * @param header - ヘッダー
 */
const unusedLabel = (header: AlterableHeaderInfo) => {
  if (header.header === 'Package' && header.unused) {
    return header.unused ? t('取引紐付け：文言不使用（数値）') : '';
  } else if (header.unused) {
    return header.unused ? t('取引紐付け：文言不使用') : '';
  } else {
    return '';
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alterableHeaderInfos, (header) => {
        return (_openBlock(), _createElementBlock("div", {
          key: `linking-input-header-${header.key}`,
          class: "linking-container__at"
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(displayHeaderTitle(header.header)), 1),
              (header.unused != null && _ctx.from !== 'HomeInput' && _unref(isRequireAlterableHeader)(header.header))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": ($event: any) => ((header.unused) = $event),
                      type: "checkbox",
                      class: "label-container__checkbox"
                    }, null, 8, _hoisted_6), [
                      [_vModelCheckbox, header.unused]
                    ]),
                    _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(t)('取引紐付け：チェックボックス：不使用')), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            (!header.unused)
              ? (_openBlock(), _createBlock(SelectableField, {
                  key: 0,
                  value: header.value,
                  "selected-id": _ctx.selectedFieldId,
                  hint: _unref(t)('取引紐付け：サジェストヒント'),
                  suggestions: _ctx.suggestions,
                  onUpdateValue: ($event: any) => (updateSelectedField(header, $event)),
                  onUpdateSelectedId: updateSelectedFieldId
                }, null, 8, ["value", "selected-id", "hint", "suggestions", "onUpdateValue"]))
              : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(unusedLabel(header)), 1))
          ]),
          _createElementVNode("span", _hoisted_9, _toDisplayString(header.validateError ? _unref(t)('取引紐付け：アラート文言：必須項目') : '　'), 1)
        ]))
      }), 128))
    ]),
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "linking-container__separator" }, null, -1)),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(InputExcelYearMonthInfo, {
        "select-year-month-pattern": _ctx.useFormatType,
        "inlined-year-month-info": _ctx.inlinedYearMonthInfo,
        "in-header-year-month-info": _ctx.inHeaderYearMonthInfo,
        onUpdateInlineHeaderName: _cache[0] || (_cache[0] = ($event) => emits('update-inline-header-name', $event)),
        onUpdateInHeaderStartColumnNumber: _cache[1] || (_cache[1] = ($event) => emits('update-in-header-start-column-number', $event)),
        onUpdateInHeaderEndColumnNumber: _cache[2] || (_cache[2] = ($event) => emits('update-in-header-end-column-number', $event)),
        onUpdateInHeaderStart: _cache[3] || (_cache[3] = ($event) => emits('update-in-header-start', $event)),
        onUpdateInHeaderEnd: _cache[4] || (_cache[4] = ($event) => emits('update-in-header-end', $event))
      }, null, 8, ["select-year-month-pattern", "inlined-year-month-info", "in-header-year-month-info"])
    ])
  ]))
}
}

})